export const getDefaultPath = (defaultPid: number | null, defaultEid: number | null): string => {
    return defaultPid ? `/p/${defaultPid}/home` : defaultEid ? `/e/${defaultEid}/realtime` : 'login';
};

const DEEP_LINK_KEY = 'tickchak.postLoginRedirect';
const ALLOWED_PREFIXES = ['/p/', '/e/', '/appPlus'];

// Returns the path only if it is a safe internal app path, otherwise null.
export const getSafeRedirectPath = (raw: unknown): string | null => {
    if(typeof raw !== 'string') return null;
    if(raw.length < 4 || raw.length > 2000) return null;   // shortest valid: '/p/1'
    if(raw[0] !== '/' || raw[1] === '/') return null;      // exactly one leading slash (blocks '//evil.com')
    if(/[\s\\]/.test(raw)) return null;                    // whitespace, backslash ('/\evil.com')
    if(raw.includes(':')) return null;                     // any scheme (javascript:, http:)
    const salesCrm = /^\/salesCrm(?:Astra|Fable)(?:[/?#]|$)/.test(raw);
    return salesCrm || ALLOWED_PREFIXES.some(p => raw.startsWith(p)) ? raw : null;
};

export const saveDeepLink = (path: string): void => {
    try {
        if(getSafeRedirectPath(path)) sessionStorage.setItem(DEEP_LINK_KEY, path);
    } catch (e) { /* storage unavailable (privacy mode) — fail safe: no capture */ }
};

// One-shot: removes the key BEFORE returning, so a value can be used at most once.
export const consumeDeepLink = (): string | null => {
    try {
        const raw = sessionStorage.getItem(DEEP_LINK_KEY);
        sessionStorage.removeItem(DEEP_LINK_KEY);
        return getSafeRedirectPath(raw);
    } catch (e) {
        return null;
    }
};
